export function formatPaymentMethodLabel(paymentType) {
  const method = String(paymentType || "").toLowerCase();
  if (!method) return "N/A";
  if (method === "pay now" || method.includes("card")) {
    return "Credit Debit Card Payment";
  }
  if (method.includes("transfer") || method.includes("bank")) {
    return "Bank Transfer Payment";
  }
  if (method.includes("cash on pickup") || method === "cop") {
    return "Cash On Pickup";
  }
  return paymentType;
}

export function isCardPayment(order) {
  const method = String(order?.paymentType || "").toLowerCase();
  return method === "pay now" || method.includes("card");
}

export function isCashOnPickup(order) {
  const method = String(order?.paymentType || "").toLowerCase();
  return method.includes("cash on pickup") || method === "cop";
}

export function isBankTransfer(order) {
  const method = String(order?.paymentType || "").toLowerCase();
  return method.includes("transfer") || method.includes("bank");
}

export function getPaymentInfo(order) {
  const displayMethod = formatPaymentMethodLabel(order?.paymentType);

  if (order?.paymentInfo) {
    return {
      ...order.paymentInfo,
      method:
        displayMethod !== "N/A" ? displayMethod : order.paymentInfo.method,
    };
  }

  if (isCardPayment(order)) {
    const webhookCalled = order?.webhookHandled === true;
    const paymentCompleted =
      webhookCalled && String(order?.paymentStatus || "").toLowerCase() === "approved";
    const details = order?.paymentDetails || {};
    const card =
      details?.fullWebhookData?.sourceOfFunds?.provided?.card || null;
    return {  
      method: displayMethod,
      methodKey: "card",
      webhookCalled,
      paymentCompleted,
      label: paymentCompleted
        ? "Credit Debit Card Payment — payment completed (webhook confirmed)"
        : webhookCalled
          ? "Credit Debit Card Payment — webhook received"
          : "Credit Debit Card Payment — awaiting payment",
      gatewayCode: details.gatewayCode || null,
      authorizationCode: details.authorizationCode || null,
      receipt: details.receipt || null,
      cardBrand: card?.brand || card?.scheme || null,
      cardNumber: card?.number || null,
      paidAt: details.date || null,
    };
  }

  if (isBankTransfer(order)) {
    const paymentCompleted =
      String(order?.paymentStatus || "").toLowerCase() === "approved";
    return {
      method: displayMethod,
      methodKey: "bank",
      webhookCalled: false,
      paymentCompleted,
      label: paymentCompleted
        ? "Bank Transfer Payment — payment verified"
        : "Bank Transfer Payment — awaiting verification",
    };
  }

  if (isCashOnPickup(order)) {
    return {
      method: displayMethod,
      methodKey: "cash",
      webhookCalled: false,
      paymentCompleted: false,
      label: "Cash On Pickup",
    };
  }

  return {
    method: order?.paymentType || "N/A",
    methodKey: "other",
    webhookCalled: false,
    paymentCompleted:
      String(order?.paymentStatus || "").toLowerCase() === "approved",
    label: order?.paymentType || "N/A",
  };
}

export function getCustomerReceiptUrl(order) {
  const shots = order?.paymentScreenshots;
  if (!Array.isArray(shots) || shots.length === 0) return null;
  return shots[0]?.screenShot || shots[0]?.screenshot || null;
}

